import { IllustrationMultipleCompartments } from "@assets/IllustrationMultipleCompartments";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { Link } from "@tanstack/react-router";
import { PageContainer } from "~/components/layout/PageContainer";
import { LineItem } from "./instant-buy";
import { AppHeader } from "~/components/layout/AppHeader";

type MultipleCompartmentsPageProps = {
	lineItem: LineItem;
};

export const MultipleCompartmentsPage = (props: MultipleCompartmentsPageProps) => {
	const { lineItem } = props;
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer
			className="px-6"
			footer={
				<Button className="w-full" size="lg" asChild>
					<Link from="/$hubMetaName/pick-up/instant-buy" to="." search={(s) => ({ ...s, lineItemId: lineItem.id })}>
						<T>{i18n.CONTINUE()}</T>
					</Link>
				</Button>
			}
		>
			<div className="-mx-6">
				<AppHeader showHelpButton={true} />
			</div>
			<h1 className="text-2xl font-breit">
				<T>{i18n.PACKAGES_MULTIPLE_COMPARTMENTS()}</T>
			</h1>
			<p className="text-sm text-muted-foreground">
				<T>{i18n.PACKAGES_MULTIPLE_COMPARTMENTS_DESC()}</T>
			</p>
			<IllustrationMultipleCompartments className="w-full h-[50vh]" />
		</PageContainer>
	);
};
